import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggerService } from 'src/app/core/services/logger.service';
import { Action } from 'src/app/shared/actions/models/action.model';
import { WebcamImage } from 'ngx-webcam';
import { DocumentImage } from 'src/app/registration/shared/models/document-image.model';
import { ActivatedRoute } from '@angular/router';
import { Status } from 'src/app/shared/status-banner/models/status.model';

const ReviewPictureMessage = 'Review the front picture';

@Component({
  selector: 'app-license-front-image',
  templateUrl: './license-front-image.component.html',
  styleUrls: ['./license-front-image.component.scss']
})
export class LicenseFrontImageComponent implements OnInit {
  @ViewChild('frontImageInput', { static: false }) frontImageInput: ElementRef<HTMLElement>;
  loading = false;
  frontImage: any;
  previewImage: any;
  actions: Action[];
  status: Status;
  enabled = true;
  private uploadedImage: any;

  constructor(
    private readonly registrationService: RegistrationService,
    private readonly sanitizer: DomSanitizer,
    private readonly logger: LoggerService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.actions = [];
  }

  ngOnInit() {
    const data = this.registrationService.getKYCVerificationData();
    if (data.documentFrontImage && data.documentFrontImage.imageAsDataUrl) {
      this.frontImage = data.documentFrontImage ? data.documentFrontImage.imageAsDataUrl : undefined;
    }

    if (this.frontImage) {
      this.reviewFrontImage();
    } else {
      this.actions.push(this.createTakePictureAction());
    }
  }

  onNavigateToProfile(): void {
    this.registrationService.navigateToProfile();
  }

  onFileChange($event: any): void {
    if (!$event || $event.files.length === 0) {
      return;
    }
    this.frontImageInput.nativeElement.nodeValue = '';
    const files = $event.files;
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = event => {
      this.reviewFrontImage();
      this.frontImage = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
      this.uploadedImage = files[0];
      this.loading = false;
    };
  }

  private onRetakeClicked(): void {
    this.frontImage = undefined;
    this.actions = [];
    this.actions.push(this.createTakePictureAction());
  }

  private saveImage(): void {
    if (this.frontImage) {
      const image = new WebcamImage(this.frontImage, '', this.uploadedImage);
      const documentImage = {
        image
      } as DocumentImage;
      this.registrationService.saveDocumentFrontImage(documentImage);
    }
  }

  private onFrontImageInputClicked(): void {
    if (!this.frontImageInput || !this.frontImageInput.nativeElement) {
      this.logger.error('input file element not found');
    }
    this.frontImageInput.nativeElement.click();
    this.loading = true;
  }

  private createTakePictureAction(): Action {
    return {
      name: 'TAKE PICTURE',
      action: (data: any) => this.onFrontImageInputClicked(),
      disabled: !this.enabled,
      color: 'take_picture'
    } as Action;
  }

  private createRetakePictureAction(): Action {
    return {
      name: 'RETAKE',
      action: (data: any) => this.onRetakeClicked(),
      disabled: !this.enabled,
      color: 'retake_picture'
    } as Action;
  }

  private createConfirmAction(): Action {
    return {
      name: 'CONFIRM',
      action: (data: any) => this.saveImage(),
      disabled: !this.enabled,
      color: 'confirm_picture'
    } as Action;
  }

  private createReviewPictureMessage(): Status {
    return {
      message: ReviewPictureMessage,
      color: 'review_picture'
    } as Status;
  }

  private reviewFrontImage(): void {
    this.actions = [];
    this.status = this.createReviewPictureMessage();
    this.actions.push(this.createRetakePictureAction());
    this.actions.push(this.createConfirmAction());
  }
}
